import { absolutePath } from "./absolutePath";

export const emailHubStatus = {
  show: ({ params = {} } = {}) => absolutePath("email_hub/status", params),
};
